
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { ListItem } from '../../backend/backendapi';
import UsersEditor from './UsersEditor';
import { GroupSelector } from '../util';

@Component({
  components: {
    UsersEditor,
  },
})
export default class TabUsers<T> extends Vue {
  @Prop({ required: true })
  group!: T;
  @Prop({ default: '' })
  readonly groupSelector!: GroupSelector<T>;
  @Prop({ required: true })
  readonly allUsers!: ListItem[];
}
